import { useEffect } from 'react';

import { incrementActiveBanners } from '~/modules/banners';
import { decrementActiveBanners } from '~/modules/banners';

import { useAppDispatch } from './redux';

export const useStickyBanner = (visible: boolean) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (visible) {
      dispatch(incrementActiveBanners());

      return () => {
        dispatch(decrementActiveBanners());
      };
    }
  }, [dispatch, visible]);
};
